
import {routerPaths} from '../../../router/routerPaths'

const HSCodesTable = () => import(/* webpackChunkName: "group-hs-codes" */ './components/HSCodesTable/HSCodesTable.vue')
const HSCodeCreate = () => import(/* webpackChunkName: "group-hs-codes-create" */ './components/HSCodeCreate/HSCodeCreate.vue')
const HSCodeEdit = () => import(/* webpackChunkName: "group-hs-codes-edit" */ './components/HSCodeEdit/HSCodeEdit.vue')
const moduleKey = 'hs-codes'


export const HSCodesRoutes = [
  {
    path: routerPaths.mainSettingsHSCodes,
    component: HSCodesTable,
    meta: {
      breadcrumbs: {
        key: [
          'dashboard',
          'HSCodes'
        ],
        items: {
          'dashboard': {
            name: 'menu_proform',
            link: routerPaths.mainSettingsHSCodes,
          },
          'HSCodes': {
            name: 'menu_hSCodes',
            link: routerPaths.mainSettingsHSCodes,
          },
        },
      },

      moduleKey: moduleKey,
      pageTitle: 'menu_hSCodes'
    },
  },
  {
    path: routerPaths.mainSettingsHSCodesCreate,
    component: HSCodeCreate,
    meta: {
      breadcrumbs: {
        key: [
          'dashboard',
          'HSCodes'
        ],
        items: {
          'dashboard': {
            name: 'menu_proform',
            link: routerPaths.mainSettingsHSCodes,
          },
          'HSCodes': {
            name: 'menu_hSCodes',
            link: routerPaths.mainSettingsHSCodesCreate,
          },
        },
      },

      moduleKey: moduleKey,
      pageTitle: 'menu_hSCodes'
    },
  },
  {
    path: routerPaths.mainSettingsHSCodesEdit,
    component: HSCodeEdit,
    meta: {
      breadcrumbs: {
        key: [
          'dashboard',
          'HSCodes'
        ],
        items: {
          'dashboard': {
            name: 'menu_proform',
            link: routerPaths.mainSettingsHSCodes,
          },
          'HSCodes': {
            name: 'menu_hSCodes',
            link: routerPaths.mainSettingsHSCodesEdit,
          },
        },
      },

      moduleKey: moduleKey,
      pageTitle: 'menu_hSCodes'
    },
  },

]
